import script from "./ListOrganizationsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ListOrganizationsView.vue?vue&type=script&lang=ts&setup=true"

import "./ListOrganizationsView.vue?vue&type=style&index=0&id=68d9ecba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68d9ecba"]])

export default __exports__